import React from 'react';
import { LoadingSpinner } from '@shared/components/LoadingSpinner';
import { ProfileDetailsCard } from './profile/ProfileDetailsCard';
import { ProfileHeader } from './profile/ProfileHeader';
import { useProfileData } from './profile/useProfileData';

interface ProfilePageProps {
  embedded?: boolean;
}

const ProfilePage: React.FC<ProfilePageProps> = ({ embedded: _embedded = false }) => {
  const {
    user,
    isEditing,
    saving,
    reactionStats,
    totalReviews,
    formData,
    setIsEditing,
    handleChange,
    handleToggleChange,
    handleColorChange,
    handleSave,
    handleCancel,
  } = useProfileData();

  if (!user) {
    return <LoadingSpinner variant="circular" size="large" message="Loading profile..." />;
  }

  return (
    <div>
      <ProfileHeader
        user={user}
        isEditing={isEditing}
        reactionStats={reactionStats}
        onEditClick={() => setIsEditing(true)}
        avatarColor={formData.avatarColor}
        totalReviews={totalReviews}
      />

      <ProfileDetailsCard
        user={user}
        isEditing={isEditing}
        saving={saving}
        formData={formData}
        onFieldChange={handleChange}
        onColorChange={handleColorChange}
        onToggleChange={handleToggleChange}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default ProfilePage;
